// Egg readiness options with their descriptions and cooking times
export const eggReadinessOptions = [
  {
    id: 'soft',
    name: 'Soft',
    description: 'Runny yolk, slightly set whites',
    durationSeconds: 4 * 60, // 4 minutes
    displayTime: '4 min',
    icon: 'Egg'
  },
  {
    id: 'medium-soft',
    name: 'Medium-Soft',
    description: 'Jammy, partially set yolk',
    durationSeconds: 6 * 60, // 6 minutes
    displayTime: '6 min',
    icon: 'Cookie'
  },
  {
    id: 'medium',
    name: 'Medium',
    description: 'Partially firm yolk, set whites',
    durationSeconds: 8 * 60, // 8 minutes
    displayTime: '8 min',
    icon: 'CircleOff'
  },
  {
    id: 'medium-hard',
    name: 'Medium-Hard',
    description: 'Mostly firm yolk, fully set whites',
    durationSeconds: 10 * 60, // 10 minutes
    displayTime: '10 min',
    icon: 'CircleDot'
  },
  {
    id: 'hard',
    name: 'Hard',
    description: 'Firm yolk, fully set whites',
    durationSeconds: 12 * 60, // 12 minutes
    displayTime: '12 min',
    icon: 'Circle'
  },
  {
    id: 'very-hard',
    name: 'Very Hard',
    description: 'Very firm yolk, fully set whites',
    durationSeconds: 14 * 60, // 14 minutes
    displayTime: '14 min',
    icon: 'CircleDashed'
  }
];

// Popular egg recipes and their cooking times
export const popularEggTypes = [
  {
    id: 'eggs-benedict',
    name: 'Eggs Benedict',
    readinessId: 'soft',
    description: 'Poached eggs for Eggs Benedict'
  },
  {
    id: 'ramen-eggs',
    name: 'Ramen Eggs (Ajitsuke Tamago)',
    readinessId: 'medium-soft',
    description: 'Marinated soft-boiled eggs for ramen'
  },
  {
    id: 'scotch-eggs',
    name: 'Scotch Eggs',
    readinessId: 'medium',
    description: 'Classic British pub snack'
  },
  {
    id: 'deviled-eggs',
    name: 'Deviled Eggs',
    readinessId: 'hard',
    description: 'Perfect for deviled egg filling'
  },
  {
    id: 'egg-salad',
    name: 'Egg Salad',
    readinessId: 'hard',
    description: 'Classic egg salad sandwich filling'
  },
  {
    id: 'cobb-salad',
    name: 'Cobb Salad Eggs',
    readinessId: 'hard',
    description: 'Traditional Cobb salad topping'
  },
  {
    id: 'nicoise-salad',
    name: 'Salade Niçoise',
    readinessId: 'medium-hard',
    description: 'Classic French salad component'
  },
  {
    id: 'onsen-tamago',
    name: 'Onsen Tamago',
    readinessId: 'soft',
    description: 'Japanese hot spring eggs'
  }
];

// Egg cooking tips
export const eggCookingTips = [
  {
    id: 'tip1',
    title: 'Prevent Cracking',
    content: 'Allow eggs to warm slightly before cooking to prevent shells from cracking when placed in hot water.'
  },
  {
    id: 'tip2',
    title: 'Easy Peeling',
    content: 'For easier peeling, place eggs in ice water immediately after cooking for about 5 minutes.'
  },
  {
    id: 'tip3',
    title: 'Fresh vs. Older Eggs',
    content: 'Slightly older eggs (7-10 days) are easier to peel than very fresh eggs.'
  },
  {
    id: 'tip4',
    title: 'Altitude Adjustment',
    content: 'At higher altitudes, water boils at a lower temperature. Add 1 minute to cooking time for every 1,000 feet above sea level.'
  },
  {
    id: 'tip5',
    title: 'Avoid Gray Yolks',
    content: 'A greenish-gray ring around the yolk indicates overcooking. Shock eggs in ice water to prevent this.'
  }
];